import { Component, OnInit, AfterViewInit } from '@angular/core';

import {distance, rastreamentosModuleName, time} from "../shared/data.service";
import {FrotaApiService} from "../../bens/frotas/shared/frota-api.service";
import {FrotasService} from "../../bens/frotas/shared/frota.service";
import {UtilService} from "../../shared/services/util.service";
import {frotasQuery, frotasQueryComGPS} from "../../bens/frotas/shared/data.service";
import {RastreamentoApiService} from "../shared/rastreamento-api.service";
import {SortService} from "../../shared/services/sort.service";
import {DataService} from "../../core/services/data.service";
import {ProjetoService} from "../../projeto/shared/projeto.service";
import {RastreamentoService} from "../shared/rastreamento.service";

declare var google: any;
declare var MarkerClusterer: any;
declare var Chart: any;
declare var moment: any;

@Component({
    template: require('./rastreamento-mapa.component.html'),
    styles: [require('./rastreamento-mapa.component.css')]
})
export class RastreamentoMapaComponent implements OnInit, AfterViewInit {
    module: any = rastreamentosModuleName;
    tabSelected: string = 'atual';
    frotaSelectId: string = 'frota';
    frotaQuery: any;
    frotaObject: any = {};
    frotaApi: string;
    loadingFrota: boolean = true;
    frotaList: any[] = [];
    timeListStart: any[] = [];
    timeListEnd: any[] = [];
    timeStart: any = {};
    timeEnd: any = {};
    distance: any = {};
    historic: any[] = [];
    loadingHistoric: boolean = false;
    msg: string;
    locationObject: any = {};
    veiculoCategoriaId: number;
    dateString: string;
    loadingEvents: boolean = false;
    events: any[] = [];
    eventSelected: any = {};
    eventsList: any[] = [];
    distanceList: any[] = [];

    private map: any;
    private timeList: any[] = [];
    private markers: any[] = [];
    private markerCluster: any;
    private polyline: any;
    private coordinates: any[] = [];
    private patternCoordinates: any;
    private showTrail: boolean = false;
    private showChart: boolean = false;
    private velocityChartDiv: any;
    private velocityChart: any;

    constructor(
        private _rastreamentoApiService: RastreamentoApiService,
        private _rastreamentoService: RastreamentoService,
        private _frotaApiService: FrotaApiService,
        private _frotaService: FrotasService,
        private _utilService: UtilService,
        private _sortService: SortService,
        private _dataService: DataService,
        private _projetoService: ProjetoService
    ) { }

    ngOnInit() {
        this.timeListStart = this._utilService.cloneObject(time);
        this.timeListEnd = this._utilService.cloneObject(time);
        this.timeList = this._utilService.cloneObject(time);
        this.distanceList = this._utilService.cloneObject(distance);
        this.distance = this.distanceList[0];

        this.frotaQuery = this._utilService.cloneObject(frotasQuery);
        this.frotaQuery.where.and.push({gpsImei: {neq: null}});
        this.frotaQuery.where.and.push({gpsModeloId: {neq: null}});
        this.veiculoCategoriaId =  this._frotaService.getTipoVeiculo();
        this.frotaApi = '/categoria/'+ this.veiculoCategoriaId;
        this.initialize();
        this.getAllFrota();
        this.getAllEvents();
    }

    ngAfterViewInit() {
        this.velocityChartDiv = document.getElementById('velocity-chart');
        this.initChart();

        // se veio da pagina de historico de rastreamento
        const e = this._rastreamentoService.getSessionStorage();
        if (e) {
            setTimeout(function() {
                $('#' + e.id + ' tr').click();
            }, 1000);

            this._rastreamentoService.clearSessionStorage();
        }
    }

    getFrotasObject(object: any) {
        this.frotaObject = object;
    }

    clickItem(item: any) {
        $('#tableRatreamento [data-collapse] tr').each(function(i, event) {
            if (this.className.search(item.id) === -1) {
                $(this).removeClass('geo-arrow--down active');
            }
        });

        this.removeMarkers();
        if (item.id !== this.frotaObject.id) {
            this.locationObject = {};
            this.frotaObject = item;

            this.getCurrentLocation();
        } else {
            this.frotaObject = {};
        }
    }

    changeStartTime() {
        if (this.timeStart.Key === 24) {
            return this.timeListEnd = [];
        }

        this.timeListEnd = this.timeList.slice(this.timeStart.Key+1, this.timeList.length);
        this.timeEnd = this.timeListEnd[0];
        this.changeEndTime();

        this.timeStart.label = this._utilService.cloneObject("das " + this.timeStart.Value);
    }

    changeEndTime() {
        this.timeEnd.label = this._utilService.cloneObject("às " +this.timeEnd.Value);
    }

    clickBuscarHistorico() {
        let date: any = document.getElementById('date');
        date = date.value;
        this.msg = '';
        if (this.frotaObject.id && date) {
            let timeStart: any = this.timeStart;
            if (timeStart) {
                timeStart = ((timeStart.Key < 10) ? '0'+timeStart.Key.toString() : timeStart.Key.toString()).concat(":00");
            }

            let timeEnd: any = this.timeEnd;
            if (timeEnd) {
                timeEnd = ((timeEnd.Key < 10) ? '0'+timeEnd.Key.toString() : timeEnd.Key.toString()).concat(":00");
            }

            let start: any = this._utilService.convertStringToDateTime(date, timeStart);
            let end: any = this._utilService.convertStringToDateTime(date, timeEnd);
            let query: any = {
                bemId: this.frotaObject.id,
                inicio: start,
                fim: end,
                distanciaMinimaPontos: this.distance.Key
            };

            this.dateString = date;
            this.removeMarkers();
            this.getHistoric(query);
        } else {
            this.msg = "Informe o veículo e a data";
            this.historic = [];
            this.removeMarkers();
        }
    }

    clickBuscarEventos() {
        let query: any = {};
        if (this.frotaObject.id) {
            query.bemId = this.frotaObject.id;
        }

        if (this.eventSelected.id) {
            query.evento = this.eventSelected.id;
        }

        let date: any = document.getElementById('date2');
        date = date.value;
        if (date) {
            date = this._utilService.convertStringToDate(date);

            let currDate: any = date;
            let currDay  = currDate.getDate(),
                currMonth = currDate.getMonth(),
                currYear = currDate.getFullYear();
            let currDate2 = new Date(currYear, currMonth, currDay);

            let tomorrowDate: any = new Date(currDate.setDate(currDate.getDate() + 1));
            let tomorrowDay  = tomorrowDate.getDate(),
                tomorrowMonth = tomorrowDate.getMonth(),
                tomorrowYear = tomorrowDate.getFullYear();
            let tomorrowDate2 = new Date(tomorrowYear, tomorrowMonth, tomorrowDay);
            query.and = [
                {
                    data: {
                        gte:currDate2
                    }
                },{
                    data: {
                        lte:tomorrowDate2
                    }
                }
            ];
        }

        this.getEvents(query);
    }

    setTab(tab:string) {
        this.tabSelected = tab;

        if (tab === 'historico') {
            setTimeout(function() {
                this.historic = [];
                if (this.frotaObject.id) {
                    this._frotaService.setAutocompleteOption(this.frotaSelectId, this.frotaObject);
                }

                this._utilService.disabledFutureDates('date');
                this.timeStart = this.timeListStart[0];
                this.changeStartTime();
            }.bind(this));
        } if (tab === 'eventos') {
            setTimeout(function() {
                this.events = [];
                this._utilService.disabledFutureDates('date2');

                let date: any = document.getElementById('date2');
                if (date) {
                    date.value = this._utilService.convertDateToString(new Date());
                }
                this.clickBuscarEventos();
            }.bind(this));
        } else {
            this.frotaObject = {};
        }
    }

    isTab(tab: string) {
        var isTab: boolean = (tab === this.tabSelected) ? true: false;
        return isTab;
    }

    frotaTemplateResult = (function(state: any) {
        var template: any = this._frotaService.templateResult(state, false);
        return template;
    }.bind(this));

    clickShowChart() {
        this.clickHideChart();
        this.velocityChartDiv.style.display = 'block';

        this.showChart = true;
        this.map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(this.velocityChartDiv);
        this.initChart();
    }

    clickHideChart() {
        this.showChart = false;
        this.velocityChart.destroy();
        let a: any = this.map.controls[google.maps.ControlPosition.LEFT_BOTTOM];
        if (a.length) {
            a.removeAt(0);
        }
    }

    private initialize() {
        const project = this._projetoService.getSessionStorage();
        let coord: any = this._dataService.getCoordinates();
        let lat: number =  coord.lat,
            lng: number = coord.lng;
        if (project) {
            lat = project.latitude;
            lng = project.longitude;
        }

        this.patternCoordinates = {lat: lat, lng: lng};
        this.initMap(lat, lng);
    }

    private initMap(lat: any, lng: any) {
        let map: any;
        let latlng: any = new google.maps.LatLng(lat, lng);
        let mapOptions: any = {
            zoom: 12,
            mapTypeControl: false,
            streetViewControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP
            },
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP
            },
        };
        map = new google.maps.Map(document.getElementById("map"), mapOptions);

        let infoContent: any = document.getElementById('info-content');
        map.controls[google.maps.ControlPosition.TOP_RIGHT].push(infoContent);

        let btn: any = document.getElementById('btnRoadmap');
        this.addMapTypeButtonEvent(btn, 'ROADMAP', map);
        btn.click();

        btn = document.getElementById('btnSatellite');
        this.addMapTypeButtonEvent(btn, 'SATELLITE', map);

        btn = document.getElementById('btnHybrid');
        this.addMapTypeButtonEvent(btn, 'HYBRID', map);

        let input: any = document.getElementById('trafficLayer');
        let trafficLayer: any = new google.maps.TrafficLayer();
        this.toogleMapLayerEvent(input, trafficLayer, map);

        input = document.getElementById('transitLayer');
        let transitLayer: any = new google.maps.TransitLayer();
        this.toogleMapLayerEvent(input, transitLayer, map);

        input = document.getElementById('trail');
        input.addEventListener('click', function(e: any) {
            this.showTrail = !this.showTrail;
            if (this.showTrail) {
                input.classList.add("active");
            } else {
                input.classList.remove("active");
                this.removePolyline();
            }
        }.bind(this));
        input.click();

        let div: any = document.getElementById('controls-map');
        map.controls[google.maps.ControlPosition.TOP_LEFT].push(div);

        let btnToggle: any = document.getElementById('btnToggle');
        btnToggle.addEventListener('click', (e: any) => {
            let x: number, lenX: number,
                found: boolean = false,
                controls: any = map.controls[google.maps.ControlPosition.TOP_RIGHT];
            for (x = 0, lenX = controls.b.length; x < lenX; x++) {
                if (controls.b[x].id === 'info-content') {
                    map.controls[google.maps.ControlPosition.TOP_RIGHT].removeAt(x);
                    found = true;
                    break;
                }
            }

            if (!found) {
                map.controls[google.maps.ControlPosition.TOP_RIGHT].removeAt(0);
                map.controls[google.maps.ControlPosition.TOP_RIGHT].push(infoContent);
                map.controls[google.maps.ControlPosition.TOP_RIGHT].push(btnToggle);
            }

        });
        map.controls[google.maps.ControlPosition.TOP_RIGHT].push(btnToggle);

        map.setCenter(latlng);
        this.map = map;

    }

    private setMarker(location: any) {
        const frota: any = this.frotaObject;
        if (frota.id) {
            const map: any = this.map;
            const latlng: any = {lat: location.latitude, lng: location.longitude};

            let rotation: number = location.angulo;
            if (!rotation) {
                rotation = 40;
            }

            let marker: any =  new google.maps.Marker({
                position: latlng,
                title: frota.identificacao,
                map: map,
                //icon: '../../assets/images/arrow-gps.svg',
                icon: {
                    path: "M 50.084,0 50.084,111.908 100.169,150.254, 50.084,0 50.084,111.908 0,150.254",
                    fillColor: '#BA1B06',
                    fillOpacity: 1,
                    strokeWeight: 0,
                    scale: .20,
                    rotation: rotation
                }
            });

            var callbackGeoCoder: any = function(response: any) {
                location.address = response;
                const infowindow: any = this.setInfowindow(location);
                infowindow.open(map, marker);
            }.bind(this);

            marker.addListener('click', function () {
                this.geocodeLatLng(latlng, callbackGeoCoder);
            }.bind(this));

            this.markers.push(marker);
            this.coordinates.push(latlng);
        }
    }

    private removeMarkers() {
        let x: number, lenX: number;
        for (x = 0, lenX = this.markers.length; x < lenX; x++) {
            this.markers[x].setMap(null);
        }

        this.markers = [];
        this.coordinates = [];
        this.removeMarkerCluster();
        this.removePolyline();
    }

    private geocodeLatLng(latlng: any, callback: any) {
        let geocoder: any = new google.maps.Geocoder;
        geocoder.geocode({'location': latlng}, function(results, status) {
            if (status === 'OK') {
                if (results[0]) {
                    callback(results[0].formatted_address);
                } else {
                    window.alert('No results found');
                }
            } else {
                window.alert('Geocoder failed due to: ' + status);
            }
        });
    }

    private setInfowindow(location: any) {
        let date: any = this._utilService.convertDateToString(location.data);
        let time: any = this._utilService.convertTimeToString(location.data);

        if (!location.address) {
            location.address = ' - ';
        }

        let content: any = '<div>' +
            '<strong>' + this.frotaObject.identificacao + '</strong>' +
            '<br> ' +
            '<p>Local: ' + location.address + '</p>' +
            '<p>Data/hora: ' + date + ' ' + time + '</p>' +
            '<p>lat: ' + location.latitude + ' / lng:' + location.longitude + '</p>' +
            '<p>Velocidade: ' + location.kmPorHora + ' km/h</p>' +
            '</div>';

        let infowindow: any = new google.maps.InfoWindow({
            content: content
        });

        return infowindow;
    }

    private setPolyline() {
        const coordinates: any = this.coordinates;

        //draw line
        let flightPath: any = new google.maps.Polyline({
            path: coordinates,
            geodesic: true,
            strokeColor: '#8075D6',
            strokeOpacity: 1.0,
            strokeWeight: 2
        });

        flightPath.setMap(this.map);
        this.polyline = flightPath;
    }

    private removePolyline() {
        if (this.polyline) {
            this.polyline.setMap(null);
        }
    }

    private setMarkerCluster() {
        // Add a marker clusterer to manage the markers.
        let markerCluster: any = new MarkerClusterer(this.map, this.markers,
            {imagePath: 'assets/markerclusterer-1.0/m/m'});

        this.markerCluster = markerCluster;
    }

    private removeMarkerCluster() {
        if (this.markerCluster) {
            this.markerCluster.clearMarkers();
        }
    }

    private getAllFrota() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                let x: any, lenX: any,
                    list: any[] = [];

                for (x = 0, lenX = Response.length; x < lenX; x++) {
                    if (Response[x].ativo) {
                        list.push(Response[x]);
                    }
                }

                this.frotaList = list;
            }
            this.loadingFrota = false;
        }.bind(this));

        const query: any = this._utilService.cloneObject(frotasQueryComGPS);
        this._frotaApiService.onGetByCategoriaQuery(this.veiculoCategoriaId, query, onDone);
    }

    private getAllEvents() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.eventsList = Response;
                this.eventsList.unshift({id: null, titulo: "— Todos os eventos —"});
                this.eventSelected = this.eventsList[0];
            }
            this.loadingFrota = false;
        }.bind(this));

        this._rastreamentoApiService.onGetAllEvents(onDone);
    }

    private getCurrentLocation() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.locationObject = Response;
                Response = this.testObject(Response);
                if (Response.latlng) {
                    const found: boolean = this.checkCoordinates(Response);

                    if (!found) {
                        //set o marker no mapa somente se as coordenadas não existirem no array
                        let rastro: any = this._utilService.cloneObject(this.coordinates);
                        this.removeMarkers();
                        this.setMarker(Response);

                        rastro.reverse();
                        rastro.unshift(this.coordinates[0]);
                        rastro = (rastro.length > 5) ? rastro.slice(0, 5) : rastro;
                        this.coordinates = rastro.reverse();
                        if(this.showTrail) {
                            this.setPolyline();
                        }

                        this.map.setCenter(Response.latlng);
                        this.map.setZoom(16);
                    }
                }
            } else {
                //this._utilService.swalMessageWarningCustom("Não foi possível obter a localidade do veículo");
            }
            setTimeout(function() {
                if (this.tabSelected === 'atual'){
                    this.getCurrentLocation();
                }
            }.bind(this), 10000);
        }.bind(this));

        if (this.frotaObject.id) {
            this._rastreamentoApiService.onGetCurrent(this.frotaObject.id, onDone);
        }
    }

    private getHistoric(query: any) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                Response = this._sortService.sortArray(Response, ['data']);

                let found: boolean,
                    latlng: any = this.patternCoordinates;
                Response.forEach((item: any) => {
                    item = this.testObject(item);
                    if (item.latlng) {
                        latlng = item.latlng;
                        found = this.checkCoordinates(item);
                        if (!found) {
                            this.setMarker(item);
                        }
                    }

                    if (item.kmPorHora) {
                        item.kmPorHora = item.kmPorHora.toFixed(2);
                    }
                });

                this.historic = Response;
                if (this.showChart) {
                    this.clickShowChart();
                }

                if (Response.length) {
                    this.setMarkerCluster();
                    this.setPolyline();

                    this.map.setCenter(latlng);
                    this.map.setZoom(16);


                } else {
                    this.msg = "Nenhum dado encontrado";
                }
            } else {
                this._utilService.swalMessageWarningCustom("Não foi possível obter a localidade do veículo");
            }
            this.loadingHistoric = false;
        }.bind(this));

        this.loadingHistoric = true;
        this._rastreamentoApiService.onGetPeriod(query, onDone);
    }

    private checkCoordinates(newLocation: any) {
        let x: number, lenX: number,
            found: boolean = false;

        for (x = 0, lenX = this.coordinates.length; x < lenX; x++) {
            if (this.coordinates[x].lat === newLocation.latitude && this.coordinates[x].lng === newLocation.longitude) {
                found = true;
            }
        }

        return found;
    }

    private testObject(location: any) {
        if (location.longitude && location.latitude) {
            location.latlng = {lat: location.latitude, lng: location.longitude};
        }

        return location;
    }

    private addMapTypeButtonEvent(btn: any, type: string, map: any) {
        btn.addEventListener('click', function(e: any) {
            let c: any = document.getElementsByClassName('btns-controls');
            let x: number, lenX:  number;
            for (x = 0, lenX = c.length; x < lenX; x++) {
                c[x].classList.remove("active");
            }
            e.target.classList.add("active");
            map.setMapTypeId(google.maps.MapTypeId[type])
        });
    }

    private toogleMapLayerEvent(input: any, layer: any, map: any) {
        input.addEventListener('click', function(e: any) {
            if (!layer.getMap()) {
                input.classList.add("active");
                layer.setMap(map);
            } else {
                input.classList.remove("active");
                layer.setMap(null);
            }
        });
    }

    private initChart() {
        const u = this.convertHistoricChart();
        const ctx = document.getElementById("myChart");
        this.velocityChart = new Chart(ctx, {
            type: 'line',
            data: {
                datasets: [{
                    fill: true,
                    lineTension: 0.1,
                    pointBorderColor: "rgba(76,135,255,0.4)",
                    pointRadius: 1,
                    backgroundColor: "rgba(76,135,255,0.4)",
                    data: u
                }]
            },
            options: {
                legend: {
                    display: false
                },
                responsive: false,
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            return tooltipItem.yLabel + 'km/h';
                        }
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            max: 150,
                            min: 0,
                            stepSize: 30,
                            callback: function (value, index, values) {
                                return value + 'km/h';
                            }
                        }
                    }],
                    xAxes: [{
                        type: 'time',
                        position: 'bottom',
                        time: {
                            displayFormats: '',
                            tooltipFormat: moment().format("HH:mm")

                        },
                        ticks: {
                            callback: function (value, index, values) {
                                return moment(value).format("HH:mm");
                            }
                        }
                    }]
                }
            }
        });
    }

    private convertHistoricChart() {
        let c: any [] = this.historic;
        //c = [{"dataCriacao":"2017-04-26T11:20:06.426Z","dataUltimaAlteracao":"2017-04-26T11:20:06.426Z","ativo":true,"ip":"179.138.116.144","porta":"61098","imei":"868683027310956","data":"2017-04-26T11:18:24.000Z","dataBusca":20170326,"gpsAtivo":true,"gpsSinalCheio":true,"gpsTempo":"11:18:20:000","latitude":-22.943928,"longitude":-45.474693,"altitude":null,"kmPorHora":53.671,"bemId":21,"gpsModeloId":1,"protocolo":"tk300","evento":"rastrear","protocoloEnvio":"udp","id":57997,"usuarioCriacaoId":null,"usuarioUltimaAlteracaoId":null,"gpsModelo":{"dataCriacao":"2017-03-27T12:35:34.581Z","dataUltimaAlteracao":"2017-04-18T11:43:28.713Z","ativo":true,"modelo":"TK303","senha":"123456","numero":"5512981461976","protocolo":"tk300","id":1,"usuarioCriacaoId":null,"usuarioUltimaAlteracaoId":null}},{"dataCriacao":"2017-04-26T11:17:41.032Z","dataUltimaAlteracao":"2017-04-26T11:17:41.032Z","ativo":true,"ip":"179.137.252.246","porta":"64168","imei":"868683027310956","data":"2017-04-26T11:17:54.000Z","dataBusca":20170326,"gpsAtivo":true,"gpsSinalCheio":true,"gpsTempo":"11:17:50:000","latitude":-22.94151,"longitude":-45.472237,"altitude":null,"kmPorHora":41.355,"bemId":21,"gpsModeloId":1,"protocolo":"tk300","evento":"rastrear","protocoloEnvio":"udp","id":57991,"usuarioCriacaoId":null,"usuarioUltimaAlteracaoId":null,"gpsModelo":{"dataCriacao":"2017-03-27T12:35:34.581Z","dataUltimaAlteracao":"2017-04-18T11:43:28.713Z","ativo":true,"modelo":"TK303","senha":"123456","numero":"5512981461976","protocolo":"tk300","id":1,"usuarioCriacaoId":null,"usuarioUltimaAlteracaoId":null}},{"dataCriacao":"2017-04-26T11:17:27.013Z","dataUltimaAlteracao":"2017-04-26T11:17:27.013Z","ativo":true,"ip":"179.137.252.246","porta":"64168","imei":"868683027310956","data":"2017-04-26T11:17:37.000Z","dataBusca":20170326,"gpsAtivo":true,"gpsSinalCheio":true,"gpsTempo":"11:17:34:000","latitude":-22.939972,"longitude":-45.47172,"altitude":null,"kmPorHora":23.798,"bemId":21,"gpsModeloId":1,"protocolo":"tk300","evento":"rastrear","protocoloEnvio":"udp","id":57989,"usuarioCriacaoId":null,"usuarioUltimaAlteracaoId":null,"gpsModelo":{"dataCriacao":"2017-03-27T12:35:34.581Z","dataUltimaAlteracao":"2017-04-18T11:43:28.713Z","ativo":true,"modelo":"TK303","senha":"123456","numero":"5512981461976","protocolo":"tk300","id":1,"usuarioCriacaoId":null,"usuarioUltimaAlteracaoId":null}},{"dataCriacao":"2017-04-26T11:16:41.158Z","dataUltimaAlteracao":"2017-04-26T11:16:41.158Z","ativo":true,"ip":"179.137.252.246","porta":"64168","imei":"868683027310956","data":"2017-04-26T11:16:54.000Z","dataBusca":20170326,"gpsAtivo":true,"gpsSinalCheio":true,"gpsTempo":"11:16:50:000","latitude":-22.936867,"longitude":-45.471387,"altitude":null,"kmPorHora":18.038,"bemId":21,"gpsModeloId":1,"protocolo":"tk300","evento":"rastrear","protocoloEnvio":"udp","id":57988,"usuarioCriacaoId":null,"usuarioUltimaAlteracaoId":null,"gpsModelo":{"dataCriacao":"2017-03-27T12:35:34.581Z","dataUltimaAlteracao":"2017-04-18T11:43:28.713Z","ativo":true,"modelo":"TK303","senha":"123456","numero":"5512981461976","protocolo":"tk300","id":1,"usuarioCriacaoId":null,"usuarioUltimaAlteracaoId":null}},{"dataCriacao":"2017-04-26T11:16:11.551Z","dataUltimaAlteracao":"2017-04-26T11:16:11.551Z","ativo":true,"ip":"179.137.252.246","porta":"64168","imei":"868683027310956","data":"2017-04-26T11:16:24.000Z","dataBusca":20170326,"gpsAtivo":true,"gpsSinalCheio":true,"gpsTempo":"11:16:19:000","latitude":-22.934348,"longitude":-45.470982,"altitude":null,"kmPorHora":39.725,"bemId":21,"gpsModeloId":1,"protocolo":"tk300","evento":"rastrear","protocoloEnvio":"udp","id":57986,"usuarioCriacaoId":null,"usuarioUltimaAlteracaoId":null,"gpsModelo":{"dataCriacao":"2017-03-27T12:35:34.581Z","dataUltimaAlteracao":"2017-04-18T11:43:28.713Z","ativo":true,"modelo":"TK303","senha":"123456","numero":"5512981461976","protocolo":"tk300","id":1,"usuarioCriacaoId":null,"usuarioUltimaAlteracaoId":null}}];
        var time, list: any[] = [];

        c.forEach((item: any) => {
            time = new Date(item.data);
            list.push({x: time, y: item.kmPorHora});
        });

        return list;
    }

    private getEvents(query: any) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                Response = this._sortService.sortArray(Response, ['data']);

                this.events = Response;

            } else {
                this._utilService.swalMessageWarningCustom("Não foi possível obter os eventos");
            }
            this.loadingEvents = false;
        }.bind(this));

        this.loadingEvents = true;
        this._rastreamentoApiService.onGetByQuery(query, onDone);

    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/rastreamento-mapa/rastreamento-mapa.component.ts
 **/